import React, { Component } from "react";
import EntryForm9 from "../../components/EntryForms/EntryForm9/EntryForm9";
import {
  handleUserInput,
  handleMappedUserInput,
} from "../../helperFunctions/EntryFormHelperFunctions/userInputHandlers";
import {
  handleCountryAutocomplete,
  countryAutocompleteHandler,
  countyAutocompleteHandler,
  cityAndMuncipalityAutocomplete,
  districtAutocompleteHandler,
} from "../../helperFunctions/EntryFormHelperFunctions/autocompleteHelpers";
import { handleDayPicker } from "../../helperFunctions/EntryFormHelperFunctions/datePickerHelper";
import axiosInstance from "../../api/utils/axiosInstance";
import { handleDropdown } from "../../helperFunctions/EntryFormHelperFunctions/handleDropdown";
import {
  validateRequiredFields,
  validateArrayFields,
} from "../../helperFunctions/validationHelpers/validateRequiredFields";
import { connect } from "react-redux";
import {
  formSubmitError,
  formSubmitSuccess,
} from "../../store/actions/forms/formActions";
import Spinner from "../../components/UI/Spinner/Spinner";
import { withRouter } from "react-router";
import { purgeUpdateAndRedirect } from "../../helperFunctions/purgeUpdateAndRedirect";
import { PURGE_UPDATE } from "../../constants/constants";

class PodaciORegRevizoraUtrecojZemlji extends Component {
  state = {
    error: false,
    requestsLoaded: false,
    update: false,
    countryList: [],
    countyList: [],
    cityAndMuncipalityList: [],
    districtList: [],
    newFormData: {
      oznDokumenta: {
        oznDokumenta: "",
      },
      userData: {
        vrOsobe: "5",
        oib: "",
        oznAkt: "",
        ime: "",
        prezime: "",
        regBroj: "",
        oibValidated: false,
        idBroj: "",
        requiredFieldsUserData: ["ime", "prezime"],
        tstampUnosa: null,
      },
      address: {
        vrAdr: "1",
        sifDrzave: "191",
        sifZupanije: "",
        nazZupanije: "",
        sifGrdOpc: "",
        nazGrdOpc: "",
        sifNaselja: "",
        nazNaselja: "",
        brPoste: "",
        ulicaKbr: "",
        permitNumber: "",
        permitDate: "",
        requiredFieldsAddress: [
          "ulicaKbr",
          "nazNaselja",
          "brPoste",
          "sifNaselja",
          "nazZupanije",
          "sifZupanije",
          "sifDrzave",
          "permitDate",
          "permitNumber",
        ],
      },
      revReg3rdParty: [
        {
          id: 1,
          vrRegistracije: "2",
          nazTijela: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          brReg: "",
          datReg: "",
        },
      ],
      selectedDropdownValue: "",
      dropDownData: [
        {
          id: 1,
          value: "Revizorsko društvo",
        },
        { id: 2, value: "Samostalni revizor" },
        { id: 3, value: "Revizorsko društvo iz druge države" },
        { id: 4, value: "Subjekt za obavljanje revizije u trećoj zemlji" },
      ],
      mjere: [],
    },
  };

  componentDidMount = () => {
    this.getCountryList();
  };

  getOsobaEdit = async (oznaka) => {
    const { idOsobe, vrOsobe } = this.props;

    const data = this.props.azuriranjeRevizora;

    const address = data[1];

    if (address.sifZupanije) {
      this.getCityAndMuncipalityList(address.sifZupanije);
    }

    if (address.sifGrdOpc) {
      this.getDistrictList(address.sifGrdOpc);
    }

    const addressRegistration = data[2].find(
      (element) => element.vrRegistracije == 1
    );

    const findRegistration = data[2].filter(
      (element) => element.vrRegistracije == 2
    );

    let registration;
    if (findRegistration.length > 0) {
      registration = findRegistration.map((element, index) => {
        return {
          id: index + 1,
          vrRegistracije: "2",
          nazTijela: element.nazTijela || "",
          sifDrzave: String(element.sifDrzave) || "",
          nazNaselja: element.nazNaselja || "",
          brPoste: element.brPoste || "",
          ulicaKbr: element.ulicaKbr || "",
          brReg: element.brReg || "",
          datReg: element.datReg || "",
        };
      });
    } else {
      registration = this.state.newFormData.revReg3rdParty;
    }

    let oznDokumenta = {};

    if (oznaka) {
      oznDokumenta.oznDokumenta = oznaka;
    } else {
      oznDokumenta.oznDokumenta = data[4].oznDokumenta;
    }

    this.setState((prevState) => ({
      update: true,
      requestsLoaded: true,
      newFormData: {
        ...prevState.newFormData,
        oznDokumenta,
        userData: {
          ...prevState.newFormData.userData,
          idOsobe: data[0].idOsobe,
          oznAkt: data[0].oznAkt,
          oib: data[0].oib || "",
          idBroj: data[0].idBroj || "",
          ime: data[0].ime,
          prezime: data[0].prezime,
          regBroj: data[0].regBroj,
          oibValidated: true,
          tstampUnosa: data[0].tstampUnosa,
        },
        address: {
          ...prevState.newFormData.address,
          sifDrzave: String(address.sifDrzave),
          sifZupanije: String(address.sifZupanije),
          nazZupanije: address.nazZupanije,
          sifGrdOpc: String(address.sifGrdOpc),
          nazGrdOpc: address.nazGrdOpc,
          sifNaselja: String(address.sifNaselja),
          nazNaselja: address.nazNaselja,
          brPoste: address.brPoste || "",
          ulicaKbr: address.ulicaKbr,
          permitNumber: addressRegistration.brReg,
          permitDate: addressRegistration.datReg,
        },
        revReg3rdParty: registration,
        mjere: data[6],
      },
    }));
  };

  getCountryList = async () => {
    const { data } = await axiosInstance.get("/sifarnici/drzave");

    this.setState(
      {
        countryList: data,
      },
      () => {
        this.getCountyList();
      }
    );
  };

  getCountyList = async () => {
    const { data } = await axiosInstance.get("/sifarnici/zupanije");
    this.setState(
      {
        countyList: data,
      },
      () => {
        if (
          this.props.match.url.includes(
            "/azuriraj/registar-subjekata-za-obavljanje-revizije-u-trecoj-zemlji-i-registar-revizora-u-trecoj-zemlji"
          )
        ) {
          if (this.props.idDrustva != this.props.match.params.id) {
            const { purgeUpdate, history } = this.props;
            purgeUpdateAndRedirect(purgeUpdate, () =>
              history.push("/pregled-registara")
            );
            return;
          }
          this.getOsobaEdit();
        } else if (
          this.props.match.url.includes(
            "/azuriraj-po-zahtjevu/registar-subjekata-za-obavljanje-revizije-u-trecoj-zemlji-i-registar-revizora-u-trecoj-zemlji"
          )
        ) {
          if (this.props.idDrustva != this.props.match.params.id) {
            const { purgeUpdate, history } = this.props;
            purgeUpdateAndRedirect(purgeUpdate, () =>
              history.push("/pregled-registara")
            );
            return;
          }
          const oznDokumenta = this.props.oznDokumenta;
          this.getOsobaEdit(oznDokumenta);
        } else {
          this.getDataFromUnosZahtjeva();
        }
      }
    );
  };

  getDataFromUnosZahtjeva = async () => {
    this.disableLoader();
  };

  disableLoader = () => {
    this.setState({
      requestsLoaded: true,
    });
  };

  getCityAndMuncipalityList = async (countyId) => {
    const { data } = await axiosInstance.get(
      `/sifarnici/gradOpcina/${countyId}`
    );

    this.setState({
      cityAndMuncipalityList: data,
    });
  };

  getDistrictList = async (id) => {
    const { data } = await axiosInstance.get(`/sifarnici/naselja/${id}`);

    this.setState({ districtList: data }, () => {});
  };

  userInputHandler = (e, objData) => {
    e.persist();
    const id = e.target.id;
    this.setState(handleUserInput(e, objData), () => {
      id === "oib" &&
        this.state.newFormData.userData.oibValidated &&
        this.fetchUserDataCoib();
    });
  };

  fetchUserDataCoib = async () => {
    const oib = this.state.newFormData.userData.oib;
    const { data } = await axiosInstance.get(`/sifarnici/oib-data/${oib}`);

    const sifGradOpcina = data.sifraGradaOpcine.replace(/^0+/, "");
    const sifraNaselja = data.sifraNaselja.replace(/^0+/, "");

    this.getCityAndMuncipalityList(data.sifraZupanije);
    this.getDistrictList(sifGradOpcina);

    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        userData: {
          ...prevState.newFormData.userData,
          ime: data.ime,
          prezime: data.prezime,
        },
        address: {
          ...prevState.newFormData.address,
          sifDrzave: data.sifraDrzave,
          sifZupanije: data.sifraZupanije,
          nazZupanije: data.nazivZupanije,
          sifGrdOpc: sifGradOpcina,
          nazGrdOpc: data.grad,
          sifNaselja: sifraNaselja,
          nazNaselja: data.naselje,
          brPoste: data.postanskiBroj,
          ulicaKbr: `${data.adresa} ${data.kucniBroj} ${data.kucniBrojDodatak}`,
        },
      },
    }));
  };

  setCountryAutocompleteHandler = (values, objectData) => {
    this.setState(handleCountryAutocomplete(values, objectData));
  };

  autocompleteCountryHandler = (values, objectData) => {
    this.setState(countryAutocompleteHandler(values, objectData));
  };
  autocompleteCountyHandler = (values, objectData) => {
    this.setState(
      countyAutocompleteHandler(
        values,
        objectData,
        this.getCityAndMuncipalityList
      )
    );
  };

  autocompleteCityHandler = (values, objectData) => {
    this.setState(
      cityAndMuncipalityAutocomplete(values, objectData, this.getDistrictList)
    );
  };

  autocompleteDistrictHandler = (values, objectData) => {
    const stateCopy = this.state;

    this.setState(districtAutocompleteHandler(values, objectData), () => {
      if (
        stateCopy.newFormData[objectData.formGroup].hasOwnProperty("brPoste") &&
        values != null
      ) {
        this.setState((prevState) => ({
          newFormData: {
            ...prevState.newFormData,
            [objectData.formGroup]: {
              ...prevState.newFormData[objectData.formGroup],
              brPoste: String(values.brPoste),
            },
          },
        }));
      }
    });
  };

  mappedUserInputHandler = (e, objectData) => {
    e.persist();
    this.setState(handleMappedUserInput(e, objectData));
  };

  handleDayClick = (date, dateString, objData) => {
    this.setState(handleDayPicker(dateString, objData));
  };

  multiplyComponent = (e, objData) => {
    e.persist();

    const lastElem = [...this.state.newFormData[objData.formGroup]];
    const addNewElement = objData.formGroup === "revReg3rdParty" && {
      id: lastElem[lastElem.length - 1].id + 1,
      vrRegistracije: "2",
      nazTijela: "",
      sifDrzave: "191",
      nazNaselja: "",
      brPoste: "",
      ulicaKbr: "",
      brReg: "",
      datReg: "",
      oibValidated: false,
    };
    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        [objData.formGroup]: [
          ...prevState.newFormData[objData.formGroup],
          addNewElement,
        ],
      },
    }));
  };

  removeComponentHandler = (e, objectData) => {
    e.persist();
    const lastElem = [...this.state.newFormData[objectData.formGroup]];
    const { formGroup } = objectData;
    const arrayLength = this.state.newFormData[formGroup].length;
    const id = e.currentTarget.id.replace(/[^0-9]/g, "");

    if (arrayLength > 1) {
      this.setState((prevState) => ({
        newFormData: {
          ...prevState.newFormData,
          [formGroup]: [
            ...prevState.newFormData[formGroup].filter(
              (element) => element.id != id
            ),
          ],
        },
      }));
    } else {
      alert("Uklanjanje nije moguće!");
    }
  };

  submitHandler = async (e) => {
    const { zahtjevAtrId } = this.props;

    const stateCopy = { ...this.state.newFormData };
    const { requiredFieldsUserData } = stateCopy.userData;
    const validateUserData = validateRequiredFields(
      stateCopy.userData,
      requiredFieldsUserData
    );
    const { requiredFieldsAddress } = stateCopy.address;
    const validateAddress = validateRequiredFields(
      stateCopy.address,
      requiredFieldsAddress
    );

    if (!validateUserData || !validateAddress) {
      this.setState(
        {
          error: true,
        },
        () => {
          this.props.formSubmitError(true, "Popunite obavezna polja!");
        }
      );
      return;
    }
    if (
      stateCopy.userData.oib.length < 1 &&
      stateCopy.userData.idBroj.length < 1
    ) {
      this.setState(
        {
          error: true,
        },
        () => {
          this.props.formSubmitError(true, "Unesite OIB ili identifikator!");
        }
      );
      return;
    }

    if (!stateCopy.userData.oibValidated && stateCopy.userData.oib.length > 0) {
      this.props.formSubmitError(
        true,
        "OIB koji ste unijeli nije ispravan! (Osnovni podaci)"
      );
      return;
    }

    let userData = { ...stateCopy.userData };
    delete userData.requiredFieldsUserData;
    delete userData.oibValidated;
    delete userData.oznAkt;

    let address = { ...stateCopy.address };

    let permitInfo = {
      vrRegistracije: "1",
      sifDrzave: address.sifDrzave,
      brReg: address.permitNumber,
      datReg: address.permitDate,
    };

    delete address.requiredFieldsAddress;
    delete address.permitDate;
    delete address.permitNumber;

    const revReg3rdParty = [...this.state.newFormData.revReg3rdParty].map(
      (element) => {
        return {
          vrRegistracije: element.vrRegistracije,
          nazTijela: element.nazTijela,
          sifDrzave: element.sifDrzave,
          nazNaselja: element.nazNaselja,
          brPoste: element.brPoste,
          ulicaKbr: element.ulicaKbr,
          brReg: element.brReg,
          datReg: element.datReg,
        };
      }
    );

    const { oznDokumenta } = this.state.newFormData;
    const addressArray = [];
    addressArray.push(permitInfo, ...revReg3rdParty);

    const submitData = [userData, address, addressArray, oznDokumenta, [{}]];

    if (this.state.update) {
      submitData.push(stateCopy.mjere);
    }
    if (!this.state.update) {
      submitData.push([]);
    }

    this.props.submitRegistarRevizora(submitData);
  };

  render() {
    const otherProps = {
      loader: this.props.loader,
      userInputHandler: this.userInputHandler,
      parentState: { ...this.state },
      mappedUserInputHandler: this.mappedUserInputHandler,
      setCountryAutocompleteHandler: this.setCountryAutocompleteHandler,
      multiplyComponent: this.multiplyComponent,
      submitHandler: this.submitHandler,
      autocompleteCountryHandler: this.autocompleteCountryHandler,
      autocompleteCountyHandler: this.autocompleteCountyHandler,
      autocompleteCityHandler: this.autocompleteCityHandler,
      autocompleteDistrictHandler: this.autocompleteDistrictHandler,
      handleDayClick: this.handleDayClick,
      dropdownHandler: this.dropdownHandler,
      getUserData: this.getUserData,
      removeComponentHandler: this.removeComponentHandler,
    };

    return (
      <>
        {this.state.requestsLoaded ? (
          <EntryForm9 {...otherProps} />
        ) : (
          <Spinner />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    zahtjevAtrId: state.formData.zahtjevAtrId,
    idDrustva: state.update.idDrustva,
    vrOsobe: state.update.vrOsobe,
    oznDokumenta: state.update.oznDokumenta,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    formSubmitError: (error, notificationMessage) =>
      dispatch(formSubmitError(error, notificationMessage)),
    formSubmitSuccess: (error, notificationMessage) =>
      dispatch(formSubmitSuccess(error, notificationMessage)),
    purgeUpdate: () => dispatch({ type: PURGE_UPDATE }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PodaciORegRevizoraUtrecojZemlji));
